// スタイル指定用

// 表示、非表示
export class CssVisibilityConst {

	static readonly VISIBLE = 'visible';	// 出す
	static readonly HIDDEN = 'hidden';		// 消す
	static readonly COLLAPSE = 'collapse';	// テーブル（表）の行や列にこの値を指定すると、その部分を詰めて表示

}

// 要素の表示形式
export class CssDisplayConst {

	static readonly NONE 	= 'none';		// 消す
	static readonly INHERIT = 'inherit';	// 親から継承
	static readonly BLOCK 	= 'block';		// ブロック
	static readonly TABLE 	= 'table';		// テーブル
	// 使うときに足す

}
